// src/theme.js

import { createTheme } from '@mui/material/styles';

// Define Poppins as the primary font family
const poppinsFont = [
  'Poppins',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  'Helvetica',
  'Arial',
  'sans-serif',
].join(',');

const theme = createTheme({
  palette: {
    primary: {
      main: '#276a78', // Match the app bar color
      light: '#4e96a5',
      dark: '#1a4b55',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ff9800', // Orange as secondary color
      light: '#ffb74d',
      dark: '#f57c00',
      contrastText: '#000000',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: poppinsFont,
    h1: {
      fontFamily: poppinsFont,
      fontWeight: 600,
    },
    h2: {
      fontFamily: poppinsFont,
      fontWeight: 600,
    },
    h3: {
      fontFamily: poppinsFont,
      fontWeight: 600,
    },
    h4: {
      fontFamily: poppinsFont,
      fontWeight: 600,
    },
    h5: {
      fontFamily: poppinsFont,
      fontWeight: 500,
    },
    h6: {
      fontFamily: poppinsFont,
      fontWeight: 500,
    },
    subtitle1: {
      fontFamily: poppinsFont,
      fontWeight: 500,
    },
    subtitle2: {
      fontFamily: poppinsFont,
      fontWeight: 400,
    },
    body1: {
      fontFamily: poppinsFont,
      fontWeight: 400,
    },
    body2: {
      fontFamily: poppinsFont,
      fontWeight: 400,
    },
    button: {
      fontFamily: poppinsFont,
      fontWeight: 500,
      textTransform: 'none', // Avoid all-caps buttons
    },
    caption: {
      fontFamily: poppinsFont,
      fontWeight: 400,
    },
    overline: {
      fontFamily: poppinsFont,
      fontWeight: 400,
    },
  },
  spacing: 8, // Default spacing multiplier
  components: {
    // Style overrides for components
    MuiAppBar: {
      styleOverrides: {
        root: {
          fontFamily: poppinsFont,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: poppinsFont,
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: poppinsFont,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: poppinsFont,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: poppinsFont,
        },
      },
    },
  },
});

export default theme;